import styled, { css } from "styled-components";
import { colors } from "../../consts";

import WrapperContainer from "../Containers/WrapperContainer";
import { Paragraph2 } from "../Text/Paragraphs";

export const StepNumber = styled(WrapperContainer)`
  width: 24px;
  height: 24px;
  min-width: 24px;
  min-height: 24px;

  border-radius: 100%;
  background: ${colors.WHITE};
  border: 2px solid;
  border-color: ${colors.RAISIN_100};

  ${Paragraph2} {
    font-size: 16px;
    font-weight: 600;
    color: ${colors.RAISIN_100};
  }
`;

const StepHeaderClickableStyles = css`
  cursor: pointer;

  &:hover {
    background: ${colors.RAISIN_20};
  }
`;

export const StepHeader = styled(WrapperContainer)`
  width: calc(100% + 32px);
  border-radius: 68px;

  padding: 8px 16px;
  margin-left: -16px;

  transition: 0.3s all;

  ${(props) => props?.isClickable && StepHeaderClickableStyles}
`;

export const StepTitle = styled(Paragraph2)`
  font-weight: 600;
`;

export const StepContentWrapper = styled(WrapperContainer)`
  height: 100%;
  min-height: 42px;
  margin-left: 12px;
`;

export const Line = styled(WrapperContainer)`
  height: 100%;
  width: 2px;
  min-width: 2px;

  border-radius: 2px;
  background: ${colors.RAISIN_100};
`;

const ActiveStepStyles = css`
  ${StepNumber} {
    background: ${colors.RAISIN_100};

    ${Paragraph2} {
      color: ${colors.WHITE};
    }
  }
`;

const DisabledStepStyles = css`
  opacity: 0.3;
`;

export const StepStyled = styled(WrapperContainer)`
  width: 100%;

  &:last-of-type {
    ${Line} {
      visibility: hidden;
    }
  }

  transition: 0.3s all;

  ${(props) => props.isActive && ActiveStepStyles}
  ${(props) => props.isDisabled && DisabledStepStyles}
`;
